var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g({tag:"component",attrs:{"to":_vm.to}},_vm.$listeners),[(_vm.icon)?_c('SvgIcon',{staticClass:"svg-icon",attrs:{"iconName":_vm.icon}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }